import React from "react";
import { ButtonActions } from "./EditButtonConfig";
import useFetchData from "../../hooks/useFetchData";

const EditPositionButtonConfig = ({
  editElementData,
  setEditElementData,
  tableID,
  places,
  type,
  device,
  actionElements,
  tableType = "statemachine"
}) => {
  const { data } = useFetchData(`/jobs/filter/?places=${places}&elements=${type}`);

  const handleButtonConfig = (config) => {
    setEditElementData(config);
  };

  return (
    <div className="p_3">
      <ButtonActions
        buttonConfig={editElementData}
        setButtonConfig={handleButtonConfig}
        smId={tableID}
        device={device}
        type={tableType}
        allJobs={data || []}
        elements={actionElements}
      />
    </div>
  );
};

export default EditPositionButtonConfig;
